$('.copy-btn').click(function() {
    let textarea = document.createElement('textarea');
    textarea.id = 't';
    textarea.style.height = 0;
    document.body.appendChild(textarea);
    textarea.value = $(this).siblings('.copy-text').text();
    let selector = document.querySelector('#t');
    selector.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    $(this).siblings('.copied-success').removeClass('hidden');
    setTimeout(function() {
        $('.copied-success').addClass('hidden');
    }, 2000);
});
